import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { OUTCOMES, TONE } from "./importOutcomes";

const MatchCell = ({ r }) => {
    if (r.match_csv_row) {
        const m = r.match_csv_row;
        return <span data-testid={`match-csv-${r.row}`}>CSV row {m.row}: {m.name || "no name"}{m.case_id ? `, Case ${m.case_id}` : ""}</span>;
    }
    if (r.match_lead) {
        const l = r.match_lead;
        return (
            <div className="space-y-0.5">
                <Link to={`/leads/${l.id}`} target="_blank" rel="noreferrer" className="text-primary hover:underline" data-testid={`view-lead-${r.row}`}>{l.name || "Unnamed lead"}</Link>
                <div className="text-[11px] text-muted-foreground">
                    {l.case_id ? `Case ${l.case_id}` : "No Case ID"} · {l.phone || "no phone"} · {l.source || "no source"} · {l.status}
                </div>
            </div>
        );
    }
    return <span className="text-muted-foreground">—</span>;
};

const Actions = ({ r, onAdd, onSkip, onLater, busy }) => {
    const open = ["existing_review", "shared_phone_conflict"].includes(r.outcome) && !["added", "skipped"].includes(r.decision);
    if (!open) {
        return r.decision ? (
            <span className="text-xs text-muted-foreground" data-testid={`decision-${r.row}`}>
                {r.decision === "added" ? "Added" : r.decision === "skipped" ? "Skipped" : "Review later"}
                {r.decided_by?.name ? ` by ${r.decided_by.name}` : ""}
            </span>
        ) : <span className="text-muted-foreground">—</span>;
    }
    return (
        <div className="flex flex-wrap gap-1">
            {r.outcome === "existing_review" && r.match_existed_before && (
                <Button size="sm" className="h-7 text-xs" onClick={() => onAdd(r)} disabled={busy} data-testid={`add-existing-${r.row}`}>
                    Add Existing Lead to This Import
                </Button>
            )}
            <Button size="sm" variant="outline" className="h-7 text-xs" onClick={() => onSkip(r)} disabled={busy} data-testid={`skip-${r.row}`}>Skip</Button>
            {r.decision !== "review_later" ? (
                <Button size="sm" variant="ghost" className="h-7 text-xs" onClick={() => onLater(r)} disabled={busy} data-testid={`review-later-${r.row}`}>Review Later</Button>
            ) : <span className="text-[11px] text-amber-700 self-center" data-testid={`decision-${r.row}`}>Marked review later</span>}
        </div>
    );
};

export const ImportResultsTable = ({ rows, ...handlers }) => (
    <div className="overflow-x-auto border border-border rounded-lg">
        <table className="w-full text-sm" data-testid="import-results-table">
            <thead className="bg-gray-50/70 text-left">
                <tr className="text-[11px] uppercase tracking-wider text-muted-foreground">
                    {["Outcome", "CSV row", "Case ID", "Name", "Phone supplied", "Explanation", "Matching record", "Available action"].map((h) => (
                        <th key={h} className="px-3 py-2 font-medium whitespace-nowrap">{h}</th>
                    ))}
                </tr>
            </thead>
            <tbody>
                {rows.map((r) => (
                    <tr key={r.row} className="border-t border-border align-top" data-testid={`result-row-${r.row}`}>
                        <td className="px-3 py-2">
                            <span className={`inline-block border rounded px-1.5 py-0.5 text-[11px] whitespace-nowrap ${TONE[OUTCOMES[r.outcome]?.tone]}`} data-testid={`outcome-${r.row}`}>
                                {OUTCOMES[r.outcome]?.short || r.outcome}
                            </span>
                        </td>
                        <td className="px-3 py-2 tabular">{r.row}</td>
                        <td className="px-3 py-2 tabular">{r.case_id || "—"}</td>
                        <td className="px-3 py-2">{r.name || "—"}</td>
                        <td className="px-3 py-2 tabular whitespace-nowrap">{r.phone_supplied || <span className="text-muted-foreground">blank</span>}</td>
                        <td className="px-3 py-2 max-w-sm text-gray-700" data-testid={`explanation-${r.row}`}>{r.explanation}</td>
                        <td className="px-3 py-2"><MatchCell r={r} /></td>
                        <td className="px-3 py-2"><Actions r={r} {...handlers} /></td>
                    </tr>
                ))}
                {rows.length === 0 && (
                    <tr><td colSpan={8} className="px-3 py-8 text-center text-muted-foreground" data-testid="results-empty">No rows in this view.</td></tr>
                )}
            </tbody>
        </table>
    </div>
);
